import { render, staticRenderFns } from "./VSelect.vue?vue&type=template&id=04875a2e"
import script from "./VSelect.vue?vue&type=script&lang=ts"
export * from "./VSelect.vue?vue&type=script&lang=ts"
import style0 from "./VSelect.vue?vue&type=style&index=0&id=04875a2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports